export const MIN_PASSWORD_LENGTH = 8;
